const TRANSLATION = {
  common: {
    loading: 'Wird geladen',
  },
  i18n: {
    English: 'Englisch',
    Spanish: 'Spanisch',
    Russian: 'Russisch',
    'Portuguese (Brazil)': 'Portugiesisch (Brasilien)',
    Indonesian: 'Indonesisch',
    Czech: 'Tschechisch',
    German: 'Deutsch',
    French: 'Französisch',
    Italian: 'Italienisch',
    Dutch: 'Niederländisch',
    Polish: 'Polnisch',
    Vietnamese: 'Vietnamesisch',
    Turkish: 'Türkisch',
    Ukrainian: 'Ukrainisch',
    Chinese: 'Vereinfachtes Chinesisch',
    'Traditional Chinese': 'Traditionelles Chinesisch',
    Japanese: 'Japanisch',
    Korean: 'Koreanisch',
    Arabic: 'Arabisch',
    Persian: 'Persisch',
    Thai: 'Thailändisch',
    Hindi: 'Hindi',
    Malay: 'Malayisch',
    province: {
      Hebei: 'Provinz Hebei',
      Shanxi: 'Provinz Shanxi',
      Liaoning: 'Provinz Liaoning',
      Jilin: 'Provinz Jilin',
      Heilongjiang: 'Provinz Heilongjiang',
      Jiangsu: 'Provinz Jiangsu',
      Zhejiang: 'Provinz Zhejiang',
      Anhui: 'Provinz Anhui',
      Fujian: 'Provinz Fujian',
      Jiangxi: 'Provinz Jiangxi',
      Shandong: 'Provinz Shandong',
      Henan: 'Provinz Henan',
      Hubei: 'Provinz Hubei',
      Hunan: 'Provinz Hunan',
      Guangdong: 'Provinz Guangdong',
      Hainan: 'Provinz Hainan',
      Sichuan: 'Provinz Sichuan',
      Guizhou: 'Provinz Guizhou',
      Yunan: 'Provinz Yunnan',
      Shaanxi: 'Provinz Shaanxi',
      Gansu: 'Provinz Gansu',
      Qinghai: 'Provinz Qinghai',
      Taiwan: 'Provinz Taiwan',
      Guangxi: 'Autonome Region Guangxi der Zhuang',
      Neimenggu: 'Autonome Region Innere Mongolei',
      Tibet: 'Autonome Region Tibet',
      Ningxia: 'Autonome Region Ningxia der Hui',
      Xinjiang: 'Autonome Region Xinjiang der Uiguren',
      HongKong: 'Sonderverwaltungsregion Hongkong',
      Macau: 'Sonderverwaltungsregion Macau',
      Beijing: 'Stadtprovinz Peking',
      Tianjin: 'Stadtprovinz Tianjin',
      Shanghai: 'Stadtprovinz Shanghai',
      Chongqing: 'Stadtprovinz Chongqing',
    },
  },
  pageHeader: {
    product: 'Produkt',
    tvcTest: 'TVC-Erlebnis-Test',
    tvcEval: 'TVC-Kreativbewertung',
    contactUs: 'Kontaktieren Sie uns',
    Pricing: 'Preise',
    Dashboard: 'Jetzt starten',
    signIn: 'Anmelden',
    signUp: 'Registrieren',
    resourceCenter: 'Blog',
    all: 'Alle',
    news: 'News',
    insight: 'Insight',
    case: 'Case',
  },
  productSwitch: {
    common: {
      comingSoon: 'Demnächst verfügbar',
    },
    modal: {
      heroTitle: 'Bitte wählen Sie den Test aus, den Sie durchführen möchten',
      heroSubtitle:
        'AdEff ist jederzeit bereit, Ihnen multidimensionale kreative Einblicke zu liefern.',
      remainingTimes: 'Verbleibende Male: {{count}}',
      supportedAssets: 'Unterstützte Assets',
      coreMetrics: 'Kernmetriken',
      cognitiveNeuroscienceIndicators: 'Kognitiv-neuronale Indikatoren',
      consumerAttitudeIndicators: 'Verbrauchereinstellungsindikatoren',
      outputResult: 'Ausgaberesultat',
      dataReport: 'Datenbericht',
      analysisReport: 'Analysebericht',
      accessBackend: 'Jetzt starten',
      tabs: {
        tvc: 'Horizontaler Kreativtest',
        portrait: 'Vertikaler Kreativtest',
      },
      cards: {
        tvcQuick: {
          title: 'Horizontal-Schnelltest',
          descriptionHighlight:
            'Kreative schnell bewerten, um datenbasierte Entscheidungen zu treffen',
        },
        tvcBase: {
          title: 'Horizontale-Kreativdiagnose',
          descriptionHighlight:
            'Feinabstimmung kreativer Details mit umsetzbaren Änderungsempfehlungen',
          value1: '10–60 Sekunden TVC/OTV-Creatives',
          value2: 'Kognitiv-neuronale Indikatoren',
        },
        tvcSurvey: {
          title: 'Horizontale-InsightPro',
          descriptionHighlight:
            'Mehrdimensionale Kreativanalyse mit strategischer Optimierungsanleitung',
          value1: '10–60 Sekunden TVC/OTV-Creatives',
          value2: 'Kognitiv-neuronale Indikatoren',
        },
        portraitQuick: {
          title: 'Vertikal-Schnelltest',
          descriptionHighlight:
            'Kreative schnell bewerten, um datenbasierte Entscheidungen zu treffen',
        },
        portraitBase: {
          title: 'Vertikale-Kreativdiagnose',
          descriptionHighlight:
            'Feinabstimmung kreativer Details mit umsetzbaren Änderungsempfehlungen',
          value1: '5–90 Sekunden vertikale Creatives',
          value2: 'Kognitiv-neuronale Indikatoren',
        },
        portraitSurvey: {
          title: 'Vertikale-InsightPro',
          descriptionHighlight:
            'Mehrdimensionale Kreativanalyse mit strategischer Optimierungsanleitung',
          value1: '5–90 Sekunden vertikale Creatives',
          value2: 'Kognitiv-neuronale Indikatoren',
        },
      },
    },
    hoverPanel: {
      columns: {
        tvc: {
          bannerTitle: 'Horizontaler Kreativtest',
          assetText: 'Für 10-60 Sek. TVC/OTV-Kreationen',
        },
        portrait: {
          bannerTitle: 'Vertikaler Kreativtest',
          assetText: 'Für 5-90 Sek. vertikale Kreationen',
        },
      },
      items: {
        tvcQuick: {
          description: 'Kreatives schnell vergleichen und entscheiden',
        },
        tvcBase: {
          title: 'Kreativdiagnose',
          description: 'Sekunde-für-Sekunde-Optimierung für präzisere Kreationen',
        },
        tvcSurvey: {
          title: 'Tiefenanalyse',
          description: 'Umfassende Analyse, Probleme gezielt identifizieren',
        },
        portraitBase: {
          title: 'Kreativdiagnose',
          description: 'Sekunde-für-Sekunde-Optimierung für präzisere Kreationen',
        },
        portraitQuick: {
          description: 'Kreatives schnell vergleichen und entscheiden',
        },
        portraitSurvey: {
          title: 'Tiefenanalyse',
          description: 'Umfassende Analyse, Probleme gezielt identifizieren',
        },
      },
    },
  },
  cookieAcceptNotification: {
    title: 'Wir verwenden Cookies',
    desc: 'Wir verwenden notwendige Cookies, um sicherzustellen, dass unsere Website ordnungsgemäß funktioniert. Mit Ihrer Zustimmung verwenden wir auch Analyse-Cookies, um Ihr Benutzererlebnis zu verbessern. Sehen Sie sich unsere Cookie-Richtlinie in unserer Datenschutzrichtlinie an.',
    btn1: 'Alle ablehnen',
    btn2: 'Alle akzeptieren',
    cookiePolicy: 'Cookie-Richtlinie',
  },
  landing: {
    banner: {
      text1: 'KI-gesteuert',
      text2: 'Werbung',
      text3: 'Tests',
      text4: 'Plattform für kreative Tests und Optimierung',
      feature1: 'Inhaltsdekodierung',
      feature2: 'Feedbackvorhersage',
      feature3: 'Datenintegration',
      feature4: 'Schlussfolgerungsableitung',
      btn1: 'Demo anfordern',
      btn2: 'Projekt erstellen',
    },
    info: {
      title:
        'Schnelle Umsetzung der Effektvorhersage kreativer Inhalte basierend auf dem Hypergraph-Multimodalen großen Sprachmodell (HMLLM)* zur Steigerung der Werberendite',
      subTitle:
        '*Dieses Modell basiert auf einer Vielzahl von neurowissenschaftlichen Marketingtests und Multi-Agenten-Konstruktionen',
      detail1: 'Schnelle Werbungstests',
      detail1Desc:
        'AdEff kann innerhalb von 15 Minuten die Aufmerksamkeitskurve der Zielgruppe, emotionale Schwankungen und das Engagement mit kreativen Inhalten erfassen und detaillierte Bewertungsberichte sowie Optimierungsanleitungen bereitstellen.',
      detail2: 'Schnelle Auswahl der besten Kreative',
      detail2Desc:
        'AdEff unterstützt die gleichzeitige Messung mehrerer Kreative und hilft Marken, schnelle Entscheidungen zu treffen. Detaillierte Vergleichsanalyse wird bereitgestellt.',
      detail3: 'Ein-Klick-Bearbeitung, Erstellung vielfältiger effektiver Versionen',
      detail3Desc:
        'AdEff unterstützt die Ein-Klick-Bearbeitung und kann schnell vielfältige effektive Versionen erstellen, die für verschiedene Kommunikationsszenarien geeignet sind.',
    },
    advantages: {
      title: 'Vorteile von AdEff',
      item1Title: 'Schnelle Reaktion',
      item1Desc: 'Schnellste <tmp>15 Minuten</tmp> bis zum Bericht.',
      item2Title: 'Einzigartiges KI-Modell',
      item2Desc: 'Einzigartiges <tmp>KI-Modell</tmp> basierend auf dem Feedback der Zielgruppe.',
      item3Title: 'Visualisierte Diagramme',
      item3Desc:
        '<tmp>Visualisierte Diagramme</tmp> + KI-gestützte Interpretation, Testberichte auf Knopfdruck generiert',
      item4Title: 'Umfangreiche Datenbasis',
      item4Desc: '<tmp>50.000+</tmp> Kreativdatenbank',
      item5Title: 'Expertenteam',
      item5Desc: '<tmp>Expertenteam</tmp> bietet Unterstützung und Anleitung',
    },
    service: {
      title: 'AdEff-Serviceoptionen',
      desc: 'Wählen Sie die benötigte Serviceoption',
      topTitle: 'Online-Selbstbedienung',
      topRow1: 'Eigenständige Projektentwicklung und Testdurchführung',
      topRow2: 'Visualisierte Diagramme + KI-Interpretationsbericht',
      topRow3: 'Objektive neurowissenschaftliche Indikatorenanalyse (Augenbewegung + EEG)',
      topRow4: 'Einzigartiger KI-Modelltest',
      bottomTitle: 'Expertenteam-Service',
      bottomRow1: 'Experten erstellen Projekte und führen Tests durch',
      bottomRow2:
        'Objektive neurowissenschaftliche Indikatorenanalyse (Augenbewegung + EEG), optional mit subjektiven Indikatoren',
      bottomRow3: 'Visualisierte Diagramme + Experteninterpretationsbericht',
      bottomRow4: 'Einzigartiger KI-Modelltest, optional mit realen Proben',
    },
    footer: {
      title:
        'AdEff basiert auf dem Hypergraph-Multimodalen großen Sprachmodell (HMLLM) und baut komplexe Beziehungen zwischen visuellen Elementen, EEG-Signalen und Augenbewegungsdaten auf, um kreative Werbung schnell zu testen',
      email: 'E-Mail',
      belongDesc: 'Produkt von <tmp>Mininglamp Technology</tmp>',
    },
    startBtn: 'Jetzt starten',
  },
  contact: {
    title: 'Kontaktieren Sie uns',
    copy: 'Kopieren',
    message: { success: 'Erfolgreich kopiert' },
  },
  pricing: {
    title: 'KI-gesteuerter Experte für kreatives Testen und Optimierung',
    starter: {
      title: 'Starter',
      desc_1: 'Geeignet für einmalige Tests, sofort einsatzbereit nach dem Kauf',
      desc_2: 'Geeignet für kleine Tests, sofort einsatzbereit nach dem Kauf',
      timesDesc: '<strong>{{count}}</strong> Mal testen',
      timesDesc1: '<strong>{{count}}</strong> Mal testen',
      discount: '50% Rabatt',
      originPrice: 'Originalpreis',
      desc2: 'KI-basierte Werbungstests basierend auf der Zielgruppenfeedback-Datenbank',
      desc3: 'Schnellste Berichterstattung in 15 Minuten',
      desc4: 'Umfangreiche Diagramme',
      desc5: 'KI-gestützte Interpretation',
      desc6: 'Globale Datenbank und Vergleichsanalyse',
      cardDesc1: 'Zeitlich begrenzter Rabatt, nur {{pricePerTest}}',
      cardDesc2: 'Testkontingent dauerhaft gültig',
    },
    premium: {
      time: 'Mal',
    },
    unlimited: {
      title: 'Unlimited',
      cardDesc1: 'Schon ab {{pricePerTest}}',
      cardDesc2: 'Kontingent ein Jahr gültig',
      cardDesc3: 'Individuell angepasster eigener Benchmark',
      planDesc500: 'Genießen Sie 500 Tests pro Jahr',
      planDesc1000: 'Genießen Sie 1.000 Tests pro Jahr',
    },
    benefits: {
      title: 'Warum AdEff wählen?',
      subtitle: 'Mit AdEff erhalten Sie folgende Vorteile:',
      expertSupport: 'Support und Beratung durch Expertenteams',
      moreNeedsTitle: 'Haben Sie weitere Kaufanforderungen?',
      customPlanPrefix: 'Wir unterstützen flexible und maßgeschneiderte Lösungen — kontaktieren Sie uns unter',
      customPlanSuffix: 'für Ihr exklusives Angebot',
    },
    subscribeBtn: 'Jetzt abonnieren',
    contactUs: 'Kontaktieren Sie uns',
  },
  login: {
    loginText: 'Anmelden',
    signUpText: '<tmp>Registrieren</tmp> kostenlos',
    text1: 'Erfolgreich dem Team beigetreten',
    text1Desc: 'Sie können jetzt Werbungstests durchführen',
    text2: 'Der Benutzer ist dem Unternehmen beigetreten',
    text3: 'Team-Einladung ist abgelaufen',
    text4: 'Der Team-Einladungslink ist nicht mehr gültig.',
    optionText1: 'Haben Sie bereits ein Konto?',
    optionText2: 'Haben Sie kein Konto?',
    alertText1: 'Durch die Registrierung stimme ich zu',
    alertText2: 'Ich stimme zu',
    termsOfService: 'Nutzungsbedingungen',
    privacy: 'Datenschutzrichtlinie',
    privacyTips: 'Bitte überprüfen Sie das Zustimmungsfeld, bevor Sie sich anmelden.',
    and: 'und',
    or: 'oder',
    next: 'Nächster',
    googleLogin: 'Mit Google anmelden',
    googleSignUp: 'Mit Google registrieren',
    loginWithEmail: 'Mit E-Mail anmelden',
    signUpWithEmail: 'Mit E-Mail registrieren',
    password: 'Passwort',
    emailAddress: 'E-Mail-Adresse',
    enterEmail: 'Geben Sie Ihre E-Mail-Adresse ein',
    enterPassword: 'Geben Sie Ihr Passwort ein',
    confirmPassword: 'Passwort bestätigen',
    forgotPassword: 'Passwort vergessen?',
    inconsistentPassword: 'Passwörter stimmen nicht überein',
    verificationCode: 'Bestätigungscode',
    emptyVerificationCode: 'Bestätigungscode darf nicht leer sein',
    enterVerificationCode: 'Geben Sie den Bestätigungscode ein',
    sendedVerificationCode: 'Bestätigungscode wurde an Ihre E-Mail gesendet',
    emailOrPasswordNotCorrect: 'E-Mail oder Passwort ist nicht korrekt.',
    message: {
      text1: 'Eingabe ungültig',
      text2: 'E-Mail ist bereits registriert',
      text3: 'Bestätigungscode ist ungültig!',
      text4: 'Dieses Konto ist nicht mit dem Unternehmen verbunden, bitte erneut verbinden!',
      text5: 'Bitte geben Sie ein gültiges E-Mail-Format ein',
      text6: 'Passwort mindestens 12 Zeichen lang',
      text7: 'Passwort muss Großbuchstaben, Kleinbuchstaben und Zahlen enthalten',
      requestLimit: 'Anfrage überschritten, bitte später erneut versuchen',
    },
  },
  resetPwdPage: {
    submit: 'Senden',
    emailNotFound: 'Bitte überprüfen Sie Ihre E-Mail',
    emailHasSent: 'E-Mail wurde an {{email}} gesendet',
    checkYourInbox: 'Überprüfen Sie Ihre E-Mail',
    resetYourPassword: 'Passwort zurücksetzen',
    resetLinkHasSent:
      'Ein Link zum Zurücksetzen des Passworts wurde an die E-Mail-Adresse Ihres Kontos gesendet',
    enterYourEmailAddress:
      'Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen des Passworts',
    didNotGetEmail: 'Keine E-Mail erhalten?',
    tryAgain: 'Erneut versuchen',
    goBackToSign: 'Zurück zur Anmeldung',
    email: 'E-Mail',
    enterYourEmail: 'Geben Sie Ihre E-Mail-Adresse ein',
    resetPassword: 'Passwort zurücksetzen',
    resetPwdSuccess: 'Passwort erfolgreich zurückgesetzt',
    message: {
      resetLinkCodeError: 'Der Code in der Link ist ungültig',
      requestLimit: 'Anfrage überschritten, bitte später erneut versuchen',
    },
  },
  memberRequestPage: {
    title: 'Mitgliederanfrage überprüfen',
    subTitle: 'Anfrage von:',
    deny: 'Ablehnen',
    approve: 'Zustimmen',
    teamFull: 'Team voll',
    yourTeamIsFull:
      'Ihr Team ist voll. Sie können uns kontaktieren, um mehr Mitglieder zu erhalten oder andere Mitglieder zu entfernen.',
    manageMembers: 'Mitglieder in AdEff verwalten',
    requestApproved: 'Anfrage genehmigt',
    approvedDesc:
      'Sie haben <tmp>{{name}}</tmp> genehmigt, Ihrem Team beizutreten, eine Benachrichtigungs-E-Mail wurde automatisch gesendet.',
    requestDeclined: 'Anfrage abgelehnt',
    declinedDesc:
      'Sie haben <tmp>{{name}}</tmp> abgelehnt, Ihrem Team beizutreten, eine Benachrichtigungs-E-Mail wurde automatisch gesendet.',
  },
  infoBindPage: {
    title: 'KI-gesteuerte Werbungstests',
    desc: 'Schnelle Umsetzung der Effektvorhersage kreativer Inhalte basierend auf dem Hypergraph-Multimodalen großen Sprachmodell (HMLLM)* zur Steigerung der Werberendite',
    joinAdEff: 'Treten Sie AdEff bei und beginnen Sie Ihre neue Reise',
    advantages: {
      title1: 'Stärker',
      desc1: 'Einzigartiges KI-Modell basierend auf einer umfangreichen Datenbank',
      title2: 'Kostengünstiger',
      desc2: 'Nur 10% der Kosten im Vergleich zu traditionellen Methoden',
      title3: 'Schneller',
      desc3: 'Schnellste Berichterstattung in 15 Minuten',
      title4: 'Professioneller',
      desc4: 'Genießen Sie 24/7 Support und Expertenservice',
    },
    username: 'Benutzername',
    company: 'Unternehmen',
    placeOfResidence: 'Land/Region',
    invitationCode: 'Empfehlungscode',
    createAccountForFree: 'Kostenlos ein Konto erstellen',
    refreshStatus: 'Status aktualisieren',
    reapply: 'Erneut bewerben',
    bySigningUp: 'Durch die Registrierung stimmen Sie zu',
    termsOfService: 'Nutzungsbedingungen',
    and: 'und',
    privacyPolicy: 'Datenschutzrichtlinie',
    message: {
      success: 'Anfrage zur Kontoerstellung gesendet, bitte warten!',
      success2: 'Konto erfolgreich erstellt',
      error: 'Kontoerstellung fehlgeschlagen, bitte versuchen Sie es später erneut.',
      accountCreatedDirectly: 'Ihr Konto wurde direkt erstellt!',
      theRequestHasBeenApprovedAndIsJumpingThePageForYou:
        'Die Anfrage wurde genehmigt, die Seite wird automatisch umgeleitet.',
      theRequestHasBeenSendAndPleaseBePatient: 'Anfrage gesendet, bitte warten!',
      wrongRouting: 'Routing-Fehler, die Seite wird automatisch umgeleitet.',
      yourRequestHasBeenDeclined:
        'Ihre Anfrage wurde abgelehnt. Sie können erneut beantragen, um dem Team beizutreten oder ein neues Konto ohne Einladungscode zu erstellen.',
      waitingForAdministratorReview: 'Warten auf die Überprüfung durch den Administrator',
      thisFieldIsRequired: 'Dieses Feld ist erforderlich',
      pleaseEnterTheResidence: 'Bitte Land eingeben',
      invitationCodeDoesNotExist: 'Ungültiger Empfehlungscode',
      ifYourCompanyHaveBeenJoinedPleaseWriteHere:
        'Wenn Sie dies über eine Agentur-Empfehlung nutzen, geben Sie bitte den Empfehlungscode ein',
      pleaseEnterTheUsername: 'Bitte Benutzernamen eingeben',
      pleaseEnterTheCompanyName: 'Bitte Unternehmensnamen eingeben',
      needRegisterAgain: 'Fehler in der Operation, bitte registrieren Sie sich erneut',
      alreadyBind: 'Sie haben bereits die Firma gebunden, bitte binden Sie nicht erneut',
    },
  },
  knowledgeFormPage: {
    name: 'Ihr Name',
    email: 'Ihre E-Mail',
    companyName: 'Firmenname',
    department: 'Abteilung',
    role: 'Rolle',
    country: 'Land',
    province: 'Bundesland',
    pleaseEnter: 'Bitte eingeben',
    pleaseSelect: 'Bitte auswählen',
    pleaseEnterTheName: 'Bitte geben Sie Ihren Namen ein',
    pleaseEnterTheEmail: 'Bitte geben Sie Ihre E-Mail-Adresse ein',
    pleaseEnterValidEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    pleaseEnterTheCompanyName: 'Bitte geben Sie den Firmennamen ein',
    pleaseSelectTheDepartment: 'Bitte wählen Sie die Abteilung aus',
    pleaseSelectTheRole: 'Bitte wählen Sie Ihre Rolle aus',
    pleaseSelectTheCountry: 'Bitte wählen Sie Ihr Land aus',
    pleaseSelectTheProvince: 'Bitte wählen Sie das Bundesland aus',
    textIsRequired: 'Dieses Feld ist erforderlich',
    submit: 'Absenden',
    download: 'Herunterladen',
    submitSuccess: 'Anfrage erfolgreich gesendet',
    downloadSuccess: 'Herunterladen erfolgreich',
    title1: 'Bitte füllen Sie Ihre Informationen aus, um Ressourcen zu erhalten',
    title2: 'Bitte wählen Sie die Ressourcen aus, die Sie herunterladen möchten',
  },
  dashboard: {
    pdf: {
      downloadReport: 'Bericht herunterladen',
      downloadBtnText: 'PDF herunterladen',
      content: 'Inhalt',
      theEnd: 'Ende',
      thankYouForWatching: 'Danke für das Ansehen.',
      pdfProcessing: 'PDF wird verarbeitet...',
      pdfProcessingDesc:
        'PDF Seiten: {{count}}, erwartet {{seconds}} Sekunden, speichern nach, bitte warten',
      pdfProcessingDesc2:
        'Die aktuelle Sprachversion ist nicht übersetzt, kann PDF nicht generieren',
    },
    ppt: {
      downloadBtnText: 'PPT herunterladen',
      pptProcessingDesc: 'PPT-Datei wird generiert, bitte haben Sie Geduld',
      pptProcessingDesc2:
        'Die aktuelle Sprachversion wurde nicht übersetzt, PPT kann nicht generiert werden',
      pptProcessingDesc3: 'PPT-Datei wird heruntergeladen, bitte warten...',
      translateCompleted: 'PPT-Übersetzung abgeschlossen',
      exportSuccess: 'PPT-Datei erfolgreich exportiert',
      exportFailed: 'PPT-Dateiexport fehlgeschlagen',
    },
    layout: {
      projectMenuText: 'Werbungstestprojekte',
      accountManagementText: 'Kontoverwaltung',
      myAccountText: 'Mein Konto',
      subscriptionText: 'Abonnement',
      logout: 'Abmelden',
      dataDetails: 'Datendetails',
      dataAnalysis: 'Datenanalyse',
      dataOverview: 'Datenübersicht',
      dataComparison: 'Datenvergleich',
    },
    systemMessage: {
      title: 'Systemnachricht',
      task: 'Aufgabe',
      system: 'System',
      noRelevantContent: 'Keine relevanten Inhalte gefunden',
      noMore: 'Keine weiteren Nachrichten',
    },
    projectPage: {
      createProject: 'Projekt erstellen',
      searchPlaceholder: 'Geben Sie den Projekt/Werbename/Markenname ein, um zu suchen',
      sortLabel: 'Sortierung nach Werbewirkungsindex',
      sortPlaceholder: 'Bitte wählen Sie eine Sortiermethode',
      sortOption1: 'In aufsteigender Reihenfolge nach Effektindex',
      sortOption2: 'In absteigender Reihenfolge nach Effektindex',
      filterSort: 'Filtern und sortieren',
      filterBenchmarkTitle: 'Benchmark filtern',
      sortTitle: 'Sortieren',
      tabAllCreative: 'Alle Creatives ({{count}})',
      tabGeneralCreative: 'Reguläre Creatives ({{count}})',
      tabSplashCreative: 'Splash-Creatives ({{count}})',
      generalCreativeLabel: 'Reguläres Creative',
      splashCreativeLabel: 'Splash-Creative',
      normTypePlaceholder: 'Bitte wählen Sie den Referenzwerttyp',
      totalDesc: 'Werbeprojekte (insgesamt {{total}})',
      noRelevantContent: 'Keine relevanten Inhalte gefunden',
      loadMore: 'Mehr laden',
      projectCard: { delete: 'Löschen', reanalyze: 'Neu analysieren', download: 'Herunterladen' },
      delete: 'Löschen',
      cancel: 'Abbrechen',
      message: {
        deleteTitle: 'Löschwarnung',
        delete:
          'Sobald dieses Projekt gelöscht wird, werden alle zugehörigen Daten nicht mehr zugänglich sein. Möchten Sie wirklich fortfahren?',
        delete1:
          'Dieses Projekt ist ein kostenloses Testprojekt, das nach dem Löschen nicht wieder zur Verfügung gestellt wird',
        delete2:
          'Dieses Projekt hat die Analyse noch nicht begonnen. Nach dem Löschen werden Ihre Testguthaben zurückerstattet',
        deleteSuccess: 'Löschen erfolgreich!',
        analysisCountNotEnough:
          'Analyseanzahl nicht ausreichend, bitte aufladen und erneut versuchen.',
        analysisFailed: 'Analyse fehlgeschlagen, bitte erneut versuchen.',
        waitingQuestion:
          'Maximal 3 Projekte können gleichzeitig analysiert werden. Dieses Projekt ist in die Warteschlange eingereiht und wird später automatisch mit der Analyse beginnen.',
        landscapeQuickCompleted: 'Ihr horizontales Quick-Test-Projekt ist abgeschlossen.',
        portraitQuickCompleted: 'Ihr vertikales Quick-Test-Projekt ist abgeschlossen.',
        landscapeSurveyCompleted: 'Ihr horizontales Deep-Insight-Projekt ist abgeschlossen.',
        portraitSurveyCompleted: 'Ihr vertikales Deep-Insight-Projekt ist abgeschlossen.',
      },
    },
    projectCreatePage: {
      createProject: 'Projekt erstellen',
      basicInformation: 'Grundinformationen',
      projectType: 'Projektart',
      projectName: 'Projektname',
      categoryType: 'Branche',
      brandName: 'Markenname',
      advertisingInformation: 'Werbeinformationen',
      adName: 'Werbename',
      norm: 'Referenzwert',
      targetMarketNorm: 'Zielmarkt-Referenzwert',
      brandNorm: 'Markennorm',
      taGender: 'TA Geschlecht',
      targetMarket: 'Zielmarkt',
      taAge: 'TA Alter',
      next: 'Nächster',
      previous: 'Vorheriger',
      confirmOrder: 'Bestellung bestätigen',
      estTime: 'Geschätzte Zeit',
      minutes: 'Minuten',
      consumption: 'Verbrauch dieser Bestellung',
      testPoint: 'Testpunkte',
      remaining: 'Verbleibend',
      times: 'Mal',
      type: 'Typ',
      purchase: 'Kaufen',
      outputLanguage: 'Ausgabegeschlecht',
      durationCategory: 'Kreativtyp',
      durationCategoryDesc: 'Die Analysemetriken variieren je nach Kreativtyp. Bitte wählen Sie die Option, die am besten zu Ihrem Inhalt passt.',
      durationCategoryOptions: {
        tenPlus: 'Allgemeine Kreation (10s+)',
        fiveToTen: 'Splash-Kreation (5-10s)',
      },
      adSelection: {
        adCreativeTest: 'Werbekreativtest',
        adCreativeTestDesc:
          'Testen Sie das Feedback der Zielgruppe zu einer einzelnen Werbekreative und bieten Sie Analysen und Empfehlungen an',
        adCreativeSelection: 'Werbekreativauswahl',
        adCreativeSelectionDesc:
          'Vergleichen Sie das Feedback mehrerer Werbekreativen und wählen Sie umfassend aus',
        adCreativeEditing: 'Werbekreativbearbeitung',
        adCreativeEditingDesc:
          'KI-gestützte Auswahl der besten Teile der Werbekreative, automatische Erstellung von Werbekreativen',
        launchingSoon: 'Bald verfügbar',
      },
      industryCategorySelect: {
        /**----------------------- */
        foodAndBeverageCategory: 'Lebensmittel- und Getränkebranche',
        packagedFood: 'Verpackte Lebensmittel',
        confectionery: 'Süßwaren',
        frozenMeals: 'Gefrorene Speisen',
        fastFood: 'Schnellfood',
        beverage: 'Getränke',
        alcohol: 'Alkohol',
        dairy: 'Milchprodukte',
        grainAndSeasoning: 'Getreide und Gewürze',
        beverageMixes: 'Getränke-Mixes',
        freshProduce: 'Frische Produkte',
        otherFoodAndBeverage: 'Andere Lebensmittel und Getränke',
        /**----------------------- */
        consumerElectronicsCategory: 'Konsumelektronikbranche',
        mobilePhone: 'Mobiltelefon',
        computer: 'Computer',
        smartDevice: 'Intelligente Geräte',
        phoneAccessories: 'Mobiltelefonzubehör',
        computerAccessories: 'Computerzubehör',
        software: 'Software',
        camera: 'Kamera',
        officeSupplies: 'Bürobedarf',
        otherConsumerElectronics: 'Andere Konsumelektronik',
        /**----------------------- */
        pharmaceuticalsAndHealthCareCategory: 'Pharma- und Gesundheitsbranche',
        otcMedicine: 'OTC-Medikamente',
        prescriptionDrugs: 'Rezeptmedikamente',
        healthSupplements: 'Gesundheitszusätze',
        pharmaceuticalCompanies: 'Pharmaunternehmen',
        medicalDevices: 'Medizinische Geräte',
        medicalServices: 'Medizinische Dienstleistungen',
        pharmacy: 'Apotheke',
        otherPharmaceuticalsAndHealthCare: 'Andere Pharma- und Gesundheitsbranche',
        /**----------------------- */
        beautyAndPersonalCareCategory: 'Schönheit und Körperpflege',
        hairCare: 'Haarpflege',
        womenSkincare: 'Damenhautpflege',
        homeCleaning: 'Haushaltsreinigung',
        bodyCare: 'Körperpflege',
        feminineCare: 'Damenhygiene',
        oralCare: 'Mundpflege',
        menSkincare: 'Herrenhautpflege',
        makeup: 'Make-up',
        fragrances: 'Düfte',
        beautyServices: 'Schönheitsdienstleistungen',
        otherBeautyAndPersonalCare: 'Weitere Schönheit und Körperpflege',
        /**----------------------- */
        maternalAndInfantProductsCategory: 'Mutter- und Babyprodukte',
        babyFood: 'Babynahrung',
        babyCareEssentials: 'Babybedarf',
        babyToys: 'Babyspielzeug',
        otherMaternalAndInfantProducts: 'Weitere Mutter- und Babyprodukte',
        /**----------------------- */
        networkAndCommunicationCategory: 'Netzwerk- und Kommunikationsbranche',
        mobileCarriers: 'Mobilfunkbetreiber',
        internetProviders: 'Internetanbieter',
        telecomEquipment: 'Telekommunikationsgeräte',
        otherNetworkAndCommunication: 'Andere Netzwerk- und Kommunikationsbranche',
        /**----------------------- */
        travelAndAccommodationCategory: 'Reise- und Unterkünftigungsbranche',
        localTourism: 'Reise/Region',
        bookingPlatform: 'Buchungsplatform',
        hotels: 'Hotel',
        airlines: 'Flugzeug',
        airport: 'Flughafen',
        otherTravelAndAccommodation: 'Andere Reise- und Unterkünftigungsbranche',
        /**----------------------- */
        vehiclesCategory: 'Fahrzeugbranche',
        motorVehicleProductsAndServices: 'Fahrzeugprodukte und -dienstleistungen',
        carBrands: 'Autobrand',
        dealerships: 'Autohändler',
        carFinance: 'Autofinanzierung',
        evCar: 'Elektrofahrzeug',
        motorcycle: 'Motorrad',
        onlineUsedCarMarketplace: 'Online-Gebrauchtwagenmarktplatz',
        carRentalPlatform: 'Autovermietungsplattform',
        travelNavigation: 'Reiseplanung',
        bicycle: 'Fahrrad',
        otherVehicles: 'Andere Fahrzeuge',
        /**----------------------- */
        householdAppliancesCategory: 'Haushaltsgerätebranche',
        majorAppliances: 'Großgeräte',
        healthAndPersonalCareAppliances: 'Gesundheits- und Körperpflegegeräte',
        majorKitchenAndBathAppliances: 'Große Küche und Badezimmergeräte',
        smallKitchenAppliances: 'Kleine Küche und Badezimmergeräte',
        environmentalAppliances: 'Umweltgeräte',
        cleaningAppliances: 'Reinigungsgeräte',
        otherHouseholdAppliances: 'Andere Haushaltsgeräte',
        /**----------------------- */
        retailAndServiceCategory: 'Retail- und Servicebranche',
        onlineRetailEcommerce: 'Online-Retail/E-Commerce',
        departmentStores: 'Warenhaus',
        lifeServices: 'Lebensdienstleistungen',
        retailServicesAndDelivery: 'Retail-Dienstleistungen/Lieferung',
        supermarkets: 'Supermärkte',
        otherRetailAndService: 'Andere Retail- und Servicebranche',
        /**----------------------- */
        apparelCategory: 'Kleidungsbranche',
        footwear: 'Schuhe',
        clothing: 'Kleidung',
        watchesWatchRetail: 'Uhren/Uhrenhandel',
        jewelry: 'Schmuck',
        bags: 'Taschen',
        eyewearOpticalStores: 'Brillen/Optik',
        otherClothingAndAccessories: 'Andere Kleidungs- und Accessoires',
        /**----------------------- */
        homeImprovementAndFurnishingsCategory: 'Heimwerker- und Innenausstattungsbranche',
        homeFurnishing: 'Heimwerker',
        homeImprovement: 'Innenausstattung',
        otherHomeImprovementAndFurnishings: 'Andere Heimwerker- und Innenausstattungsbranche',
        /**----------------------- */
        financialAndInsuranceCategory: 'Finanz- und Versicherungsbranche',
        bank: 'Bank',
        fintech: 'Fintech',
        investmentAndFinancialServices: 'Investment- und Finanzdienstleistungen',
        insurance: 'Versicherung',
        otherFinancialAndInsurance: 'Andere Finanz- und Versicherungsbranche',
        /**----------------------- */
        entertainmentAndLeisureCategory: 'Unterhaltung und Freizeit',
        socialApp: 'Soziales App',
        toysAndDolls: 'Spielzeug und Puppen',
        concerts: 'Konzerte',
        events: 'Sportveranstaltungen',
        movies: 'Filme',
        themeParks: 'Themenparks',
        gambling: 'Glücksspiel',
        onlineGaming: 'Online-Spiele',
        tvChannels: 'Fernsehkanäle',
        otherEntertainmentAndLeisure: 'Andere Unterhaltung und Freizeit',
        /**----------------------- */
        industrialAndAgriculturalCategory: 'Industrie- und Landwirtschaftsbranche',
        industrialSupplies: 'Industrielle Materialien',
        agriculturalSupplies: 'Landwirtschaftliche Materialien',
        otherIndustrialAndAgricultural: 'Andere Industrie- und Landwirtschaftsbranche',
        /**----------------------- */
        petLifeCategory: 'Tierleben',
        petFood: 'Tierfutter',
        petSupplies: 'Tierzubehör',
        otherPetLife: 'Andere Tierleben',
        /**----------------------- */
        educationAndLearningCategory: 'Bildung und Lernen',
        onlineLearning: 'Online-Lernen',
        schools: 'Schulen',
        skillCourses: 'Fächerkurse',
        tutoring: 'Nachhilfe',
        universities: 'Universitäten',
        otherEducationAndLearning: 'Andere Bildung und Lernen',
        /**----------------------- */
        communityAndPublicServiceCategory: 'Gemeinschaft und öffentliche Dienstleistungen',
        charityCampaigns: 'Charity-Kampagnen',
        ngoAds: 'NGO-Werbung',
        otherCommunityAndPublicService: 'Andere Gemeinschaft und öffentliche Dienstleistungen',
        /**----------------------- */
        otherCategory: 'Andere Branchen',
        governmentAdvertising: 'Regierungsreklame',
        realEstateAdvertising: 'Immobilienreklame',
        otherAdvertising: 'Andere Werbung',
      },
      genderSelect: {
        male: 'Männlich',
        female: 'Weiblich',
        all: 'Alle',
      },
      targetMarketSelect: {
        China: 'China',
        HongKongChina: 'Hongkong, China',
        MacauChina: 'Macau, China',
        TaiwanChina: 'Taiwan, China',
        Japan: 'Japan',
        Korea: 'Korea',
        Mongolia: 'Mongolei',
        Singapore: 'Singapur',
        Thailand: 'Thailand',
        Vietnam: 'Vietnam',
        Malaysia: 'Malaysia',
        Philippines: 'Philippinen',
        Indonesia: 'Indonesien',
        Cambodia: 'Kambodscha',
        Laos: 'Laos',
        India: 'Indien',
        SaudiArabia: 'Saudi-Arabien',
        Turkey: 'Türkei',
        Israel: 'Israel',
        UnitedArabEmirates: 'Vereinigte Arabische Emirate',
        Qatar: 'Katar',
        Kuwait: 'Kuwait',
        UnitedKingdom: 'Vereinigtes Königreich',
        France: 'Frankreich',
        Germany: 'Deutschland',
        Netherlands: 'Niederlande',
        Belgium: 'Belgien',
        Austria: 'Österreich',
        Italy: 'Italien',
        Spain: 'Spanien',
        Portugal: 'Portugal',
        Greece: 'Griechenland',
        Sweden: 'Schweden',
        Norway: 'Norwegen',
        Finland: 'Finnland',
        Denmark: 'Dänemark',
        Estonia: 'Estland',
        Latvia: 'Lettland',
        Russia: 'Russland',
        Poland: 'Polen',
        CzechRepublic: 'Tschechische Republik',
        Hungary: 'Ungarn',
        Romania: 'Rumänien',
        Bulgaria: 'Bulgarien',
        Slovakia: 'Slowakei',
        Slovenia: 'Slowenien',
        Ukraine: 'Ukraine',
        UnitedStates: 'Vereinigte Staaten',
        Canada: 'Kanada',
        Mexico: 'Mexiko',
        Brazil: 'Brasilien',
        LatinAmerica: 'Lateinamerika',
        Australia: 'Australien',
        NewZealand: 'Neuseeland',
        Other: 'Andere',
      },
      languageSelect: {
        english: 'Englisch',
        chinese: 'Chinesisch',
        japanese: 'Japanisch',
        korean: 'Koreanisch',
        french: 'Französisch',
        traditionalChinese: 'Traditionelles Chinesisch',
      },
      placeholder: {
        projectName: 'Bitte Projektnamen eingeben',
        category: 'Bitte Kategorie auswählen',
        brandName: 'Bitte Markennamen eingeben',
        adName: 'Bitte Werbenamen eingeben',
        norm: 'Bitte wählen Sie den Referenzwert',
        taGender: 'Bitte Geschlecht auswählen',
        targetMarket: 'Bitte Zielmarkt auswählen',
        taAge: 'Bitte Alter auswählen',
        lowerLimit: 'Untergrenze',
        upperLimit: 'Obergrenze',
        outputLanguage: 'Bitte wählen Sie die Ausgabegeschlecht',
      },
      step: {
        step1: 'Projektdaten eingeben',
        step2: 'Bestellinformationen bestätigen',
      },
      message: {
        success: 'Erfolgreich erstellt',
        videoDurationOver60s: 'Videodauer über {{max}} Sekunden',
        videoDurationLessThan10s: 'Videodauer unter {{min}} Sekunden',
        videoDurationNeedOver10s: 'Die Videodauer muss über 10 Sekunden liegen',
        videoDurationNeedWithin5To10s: 'Die Videodauer muss zwischen 5 und 10 Sekunden liegen',
        videoDurationNotMatchDurationCategory: 'Die aktuelle Videodauer erfüllt die Anforderungen dieses Projekttyps nicht. Bitte laden Sie das Video erneut hoch und versuchen Sie es erneut.',
        videoUploadingCannotSwitchDurationCategory: 'Während das Video hochgeladen wird, kann der Kreativtyp nicht gewechselt werden. Bitte warten Sie, bis der Upload abgeschlossen ist.',
        videoFormatOrDurationError: 'Videoformat oder -dauer konnte nicht gelesen werden. Bitte prüfen Sie die Videodatei und versuchen Sie es erneut.',
        videoSizeOver200M: 'Videogröße über 256 MB',
        videoLandscape: 'Video muss im Querformat sein',
        videoPortrait: 'Video muss im Hochformat sein',
        clickToUploadTestVideo: 'Klicken Sie hier, um das Testvideo hochzuladen',
        uploadFailed: 'Hochladen fehlgeschlagen, bitte erneut hochladen',
        uploadDesc1: 'Unterstützt Videodateien in MP4, MOV ',
        uploadDescPortrait: 'Unterstützt Hochformat-Videodateien in MP4, MOV',
        uploadDesc2: 'andere Formate, mit einer Dateigrößenbeschränkung von bis zu 256 MB',
        formNotCompleted: 'Bitte füllen Sie alle Informationen aus',
        uploadAdVideo: 'Bitte Werbevideo hochladen',
        inputInvalid: 'Eingabe ungültig',
        insufficientTestPoints: 'Unzureichende Testpunkte, bitte aufladen und erneut versuchen.',
        reviewProjectInfo:
          'Bitte überprüfen Sie Ihre Projektdaten sorgfältig. Nach Bestätigung der Bestellung können keine Änderungen mehr vorgenommen werden.',
        waitingDesc:
          'Bis zu 3 Projekte können gleichzeitig analysiert werden. Zusätzliche Projekte werden in die Warteschlange eingereiht und werden sequentiell vom System verarbeitet.',
        ageRangeInvalid: 'Alterbereich unterstützt nur 20-55',
        normDesc:
          'Unbegrenzte Urheberrechtsvorteile, branchen- oder historische Daten als Referenzwert für den Vergleich der Werbeleistung.',
      },
    },
    projectDetailPage: {
      testResults: 'Testergebnisse',
      share: 'Teilen',
      shareFailed: 'Teilen fehlgeschlagen',
      shareModal: {
        title: 'Teilen',
        desc: 'Kopiere den folgenden Text und teile ihn in sozialen Medien.',
        saveImage: 'Bild speichern',
        copyText: 'Text kopieren',
        copySuccess: 'Kopiert',
        copyFailed: 'Kopieren fehlgeschlagen',
        textTemplate:
          'Wow! Mein KI-Kreativ hat {{score}}% der Vergleichswerke auf AdEff übertroffen! Daten sind der echte Maßstab! AdEff KI-Creative-Testing ist jetzt kostenlos. Prüfe deinen Score auf {{hostname}}. Hol dir 5 kostenlose Tests und wir wünschen dir Top-Bewertungen!',
      },
      sharePoster: {
        createdByYou: 'Von dir erstellt',
        scoreTemplate: 'Besser als <score>{{score}}</score> der AIGC-Kreationen',
        statsAt: 'Statistik vom ',
        certification: 'Kreativitätszertifikat',
        footerText: 'Wir freuen uns auf weitere kreative und hochwertige Werke von dir!',
      },
      basicInformation: 'Grundinformationen',
      waiting: 'Wird ausgeführt',
      ongoing: 'Laufend',
      failed: 'Fehlgeschlagen',
      tryAgain: 'Erneut versuchen',
      videoAnalysisFailed: 'Videoanalyse fehlgeschlagen',
      message: { projectNotFound: 'Projekt nicht gefunden' },
      primaryAnalysis: 'Hauptleistung',
      detailAnalysis: 'Detailanalyse',
      heatmapAnalysis: 'Heatmap',
      analysisStepDesc:
        'KI hat alle Analyseaufgaben abgeschlossen, detaillierte Analysen sind wie folgt',
      analysisWaitingDesc:
        'Bis zu 3 Projekte können gleichzeitig analysiert werden. Zusätzliche Projekte werden in die Warteschlange eingereiht und werden sequentiell vom System verarbeitet.',
      aiTip: 'Der Berichtsinhalt wird von KI generiert und ist nur als Referenz gedacht',
      subAnalysisDescription: {
        adVideoScore: 'Werbewirkungsindex',
        adVideoScoreDesc:
          'Der Werbewirkungsindex ist ein umfassender Indikator für die Wirksamkeit von Werbung, der die kurzfristigen und langfristigen Verkaufseffekte von Werbungen vorhersagen kann.',
        norm: 'Norm',
        normDesc:
          'Branchen- oder historische Daten als Referenzwert für den Vergleich der Werbeleistung.',
        attentionIndex: 'Aufmerksamkeitsindex',
        attentionIndexDesc:
          'Das Maß für die visuelle Aufmerksamkeit des Publikums, das die Fähigkeit widerspiegelt, die Handlung und Elemente der Werbung anzuziehen.',
        emotionIndex: 'Emotionsindex',
        emotionIndexDesc:
          'Das Maß für das Auslösen positiver Emotionen beim Publikum, das die unmittelbaren emotionalen Schwankungen widerspiegelt, die durch die Werbung hervorgerufen werden.',
        cognitionIndex: 'Kognitionsindex',
        cognitionIndexDesc:
          'Das Maß für das Ausmaß, in dem das Publikum die Werbeinhalte verarbeitet hat.',
        theGolden3Seconds: 'Die goldenen 3 Sekunden',
        theGolden3SecondsDesc:
          'Die ersten 3 Sekunden der Werbung sind entscheidend für den Erfolg der Werbung.',
        informationTransmission: 'Informationsmoment',
        informationTransmissionDesc:
          'Das Maß für die Fähigkeit der Werbung, die Aufmerksamkeit der Zielgruppe zu erfassen und Interesse zu wecken.',
        brandRelevance: 'Markenmoment',
        brandRelevanceDesc:
          'Das Maß für die Fähigkeit des Markenmoments, die Aufmerksamkeit der Zielgruppe zu erfassen und Interesse zu wecken.',
        interestStimulation: 'Interesse-Moment',
        interestStimulationDesc:
          'Die entscheidenden Momente, die emotionale Resonanz und aktives Denken beim Publikum hervorrufen.',
        theEnding3Seconds: 'Die letzten 3 Sekunden',
        theEnding3SecondsDesc:
          'Basierend auf dem Peak-End-Gesetz sind die letzten 3 Sekunden der Werbung entscheidend, um die Aufmerksamkeit des Publikums zu festigen und die Informationsübertragung zu verstärken.',
      },
      infoDrawer: {
        basicInformation: 'Grundinformationen',
        advertisingInformation: 'Werbeinformationen',
        projectName: 'Projektname',
        brandName: 'Markenname',
        category: 'Branche',
        norm: 'Zielmarkt-Referenzwert',
        normLabel: 'Referenzwert',
        brandNorm: 'Markennorm',
        adName: 'Werbename',
        taGender: 'TA Geschlecht',
        targetMarket: 'Zielmarkt',
        taAge: 'TA Alter',
        ageRange: '{{start}} bis {{end}} Jahre',
        modify: 'Ändern',
        cancel: 'Abbrechen',
        confirm: 'Bestätigen',
      },
      videoView: {
        eyeMovementRatio: 'Aufmerksamkeitsindex',
        cognitiveEngagement: 'Kognitionsindex',
        emotionRecognition: 'Emotionsindex',
        subjectiveResponseCurve: 'Subjektive Reaktionskurve',
        realtimeData: 'Echtdaten',
        panoramicData: 'Panoramadaten',
        indexAnalysis: 'Indexanalyse',
        advantage: 'Vorteil',
        disadvantage: 'Nachteil',
        suggestions: 'Vorschläge',
        adVideoScore: 'Werbewirkungsindex',
        norm: 'Norm',
        analysisStepTitle1: 'Inhaltsdekodierung',
        analysisStepTitle2: 'Feedbackvorhersage',
        analysisStepTitle3: 'Datenintegration',
        analysisStepTitle4: 'Schlussfolgerungsableitung',
        analysisStepDesc1:
          'Beginnen Sie mit der multimodalen Dekodierung des Werbeinhalts, Dekodierung von visuellen, akustischen, textlichen und strukturellen Inhalten...',
        analysisStepDesc2:
          'Beginnen Sie mit der Vorhersage der subjektiven Reaktion des Publikums basierend auf den Inhalten der Werbung...',
        analysisStepDesc3:
          'Beginnen Sie mit der Integration objektiver Inhalte der Werbung und subjektiver Reaktionsdaten des Publikums...',
        analysisStepDesc4:
          'Beginnen Sie mit der Generierung von Bewertungs- und Handlungsempfehlungen basierend auf dem Schlussfolgemodell...',
        keyResult: 'Kernresultat',
        videoChart: {
          videoFailed: 'Video-Wiedergabe fehlgeschlagen',
          videoFailedAction:
            'Bitte aktualisieren und erneut versuchen. Wenn das Problem nach mehreren Aktualisierungen weiterhin besteht, kontaktieren Sie uns für Unterstützung.',
        },
      },
      storyboardView: {
        summary: 'Zusammenfassung',
        advantages: 'Vorteile',
        disadvantages: 'Nachteile',
        suggestions: 'Vorschläge',
        keyResult: 'Kernresultat',
        norm: 'Norm',
        theGolden3Seconds: 'Die goldenen 3 Sekunden',
        informationTransmission: 'Informationsmoment',
        brandRelevance: 'Markenmoment',
        interestStimulation: 'Interesse-Moment',
        theEnding3Seconds: 'Die letzten 3 Sekunden',
      },
      heatmapView: {},
    },
    accountPage: {
      email: 'E-Mail',
      username: 'Benutzername',
      password: 'Passwort',
      setPasswordToEnableEmailLogin: 'Passwort festlegen, um die E-Mail-Anmeldung zu aktivieren',
      uid: 'UID',
      contactAndReceiveNotifications: 'Kontaktieren und Benachrichtigungen erhalten',
      receiveEmailsAboutAdeffLatestUpdatesWithThisEmail:
        'Erhalten Sie E-Mails über die neuesten Updates von AdEff an diese E-Mail-Adresse.',
      myWorkspace: 'Mein Arbeitsbereich',
      newRequest: 'Neue Anfrage',
      invitationCode: 'Empfehlungscode',
      userName: 'Benutzername',
      invitationCodeDesc:
        'Jedes Team hat einen einzigartigen Einladungscode, der neuen Benutzern während der Registrierung hilft, dem Team beizutreten',
      table: {
        userName: 'Benutzername',
        email: 'E-Mail',
        operation: 'Aktion',
        admin: 'Administrator',
        remove: 'Entfernen',
        deny: 'Ablehnen',
        approve: 'Zustimmen',
      },
      message: {
        yourTeamIsFull:
          'Ihr Team ist voll. Sie können uns kontaktieren, um mehr Mitglieder zu erhalten oder andere Mitglieder zu entfernen.',
        invitationLinkSent: 'Einladungslink wurde an diese E-Mail-Adresse gesendet!',
        removeReminder: 'Entfernen-Warnung',
        remove: 'Entfernen',
        removeMember:
          'Nach dem Entfernen des Mitglieds bleiben die von diesem Mitglied erstellten Inhalte erhalten. Möchten Sie das Mitglied wirklich entfernen?',
        removeMemberSuccess: 'Mitglied erfolgreich entfernt!',
        ok: 'OK',
        contactUs: 'Kontaktieren Sie uns',
        applicationProcessedSuccessfully: 'Antrag erfolgreich bearbeitet!',
        notificationSettingsTurnedOn: 'Benachrichtigungseinstellungen aktiviert',
        notificationSettingsTurnedOff: 'Benachrichtigungseinstellungen deaktiviert',
        setPassword: 'Passwort festlegen',
        passwordConfirm: 'Bestätigen',
        passwordCancel: 'Abbrechen',
        oldPassword: 'Altes Passwort',
        newPassword: 'Neues Passwort',
        pleaseEnterTheOldPassword: 'Bitte altes Passwort eingeben',
        pleaseEnterTheNewPassword: 'Bitte neues Passwort eingeben',
        incorrectEntryOfOriginalPassword: 'Eingabe des ursprünglichen Passworts ist falsch',
        passwordUpdatedSuccessfully: 'Passwort erfolgreich aktualisiert',
        changeUsername: 'Benutzernamen ändern',
        confirm: 'Bestätigen',
        cancel: 'Abbrechen',
        username: 'Benutzername',
        pleaseEnterTheNewUsername: 'Bitte neuen Benutzernamen eingeben',
        userNameUpdatedSuccessfully: 'Benutzername erfolgreich aktualisiert',
        addMemberToWorkspace: 'Neues Mitglied zum Arbeitsbereich hinzufügen',
        notAdminOperate: 'Nicht Administrator, kann nicht operieren',
        emailAddress: 'E-Mail-Adresse',
        send: 'Senden',
        willSendAnInvitationEmailToThisAddressForConfirmation:
          'Wir werden an diese Adresse eine Einladung zur Bestätigung senden.',
        workspaceMemberShip: 'Arbeitsbereichsmitgliedschaft',
        forMoreMembership: 'Für mehr Mitgliedschaften',
        reachedTheCeiling: 'Die maximale Anzahl wurde erreicht.',
        incorrectMailboxFormat: 'E-Mail-Format ist ungültig',
        member: 'Mitglied',
        changeCorpNameTitle: 'Firmenname ändern',
        changeCorpNameLabel: 'Firmenname',
        pleaseEnterTheCorpName: 'Bitte geben Sie den Firmennamen ein',
        changeCorpNameSuccess: 'Firmenname erfolgreich geändert',
        changeCorpNameFailed: 'Firmenname ändern fehlgeschlagen',
        noPermission: 'Sie haben keine Berechtigung, den Firmennamen zu ändern',
      },
    },
    subscriptionPage: {
      currentPlan: 'Aktueller Plan',
      getInvoice: 'Ihre Rechnung abrufen',
      remainingTimes: 'Verbleibende Zeiten',
      purchaseMore: 'Mehr kaufen',
      contactUs: 'Kontaktieren Sie uns',
      teamPlan: 'Expertenteam-Service',
      unlimited: 'Unlimitiert',
      dueDate: 'Ablaufdatum',
      table: {
        usageRecords: 'Nutzungsprotokolle',
        date: 'Datum',
        projectName: 'Projektname',
        projectType: 'Projektart',
        usageCount: 'Mal',
        userName: 'Benutzername',
        noRelevantContent: 'Keine relevanten Inhalte gefunden',
      },
    },
    portraitDataDetailPage: {
      regularCreativeProject: 'Reguläres Creative-Projekt',
      regularCreative: 'Reguläres Creative',
      splashCreativeProject: 'Splash-Creative-Projekt',
      splashCreative: 'Splash-Creative',
      projects: 'Projekte',
      localNorm: 'Lokaler Benchmark',
      projectPassRate: 'Projekt-Bestehensrate',
      passRate: 'Bestehensrate',
    },
    dataDetailPage: {
      baseData: 'Basisdaten',
      totalProjects: 'Gesamtanzahl der Projekte',
      totalProjectsDesc:
        'Anzahl aller effektiven Projekte, die an der Bewertung der Werbewirksamkeit teilgenommen haben.',
      // averageEffectivenessIndex: 'Durchschnittlicher Wirkungsindex',
      // averageEffectivenessIndexDesc:
      // 'Der Durchschnittswert des Werbewirkungsindex aller effektiven Projekte.',
      localNormProjects: 'Lokale Referenzwert-Projekte',
      brandNormProjects: 'Marken-Referenzwert-Projekte',
      normProject: 'Zielmarkt-Referenzwert-Projekt',
      brandNormProject: 'Marken-Referenzwert-Projekt',
      localNorm: 'Lokale Referenzwert',
      localNormDesc:
        'Der durchschnittliche Werbewirkungsindex aller gültigen Werbeprojekte, die Ihr Land als Zielmarkt haben.',
      norm: 'Referenzwert',
      brandNorm: 'Marken-Referenzwert',
      brandNormDesc:
        'Der durchschnittliche Werbewirkungsindex aller gültigen Werbeprojekte, die Ihr benutzerdefinierte Markenreferenzwert als Zielmarkt haben.',
      localProjectPassRate: 'Lokale Projektbestehensrate',
      projectPassRate: 'Projekt-Bestehensrate',
      brandProjectPassRate: 'Markenprojekt-Bestehensrate',
      projectPassRateDesc:
        'Der Anteil der Projekte, deren Werbewirkungsindex über dem Referenzwert liegt, an der Gesamtzahl der bewerteten Projekte.',
      advertisingEffectivenessIndexDistribution: 'Verteilung des Werbewirkungsindex',
      advertisingEffectivenessIndexDistributionDesc:
        'Anteil der Projekte in verschiedenen Bereichen des Werbewirkungsindex.',
      item: 'Elemente',
    },
    dataComparisonPage: {
      createCompare: 'Neuer Vergleich',
      createCompareDesc: 'Wählen Sie mehrere Projekte zum Vergleichen aus, maximal 10 Projekte.',
      startCompare: 'Vergleich starten',
      compareReport: 'Vergleichsberichte',
      searchPlaceholder: 'Name des Vergleichsberichts suchen',
      emptyText: 'Noch keine Vergleichsberichte. Wählen Sie zuerst Projekte zum Vergleichen aus.',
      searchEmptyText: 'Keine Vergleichsberichte gefunden.',
      deleteTitle: 'Vergleichsbericht löschen',
      deleteConfirm: 'Möchten Sie diesen Vergleichsbericht wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
      projectCount: '{{count}} Projekte',
    },
    dataComparisonStartPage: {
      back: 'Zurück',
      basicInfo: 'Basisinformationen',
      reportName: 'Berichtsname:',
      reportNamePlaceholder: 'Namen des Vergleichsberichts eingeben',
      norm: 'Benchmark:',
      normPlaceholder: 'Benchmark auswählen',
      normTip: 'Wählen Sie die Benchmark für den Projektvergleich aus',
      selectProject: 'Projekte auswählen',
      searchPlaceholder: 'Nach Projekt/Anzeige/Marke suchen',
      selectedCountPrefix: ' Ausgewählt ',
      selectedCountSuffix: ' Projekte, bis zu {{max}} Projekte',
      startCompare: 'Vergleich starten',
      save: 'Speichern',
      cancel: 'Abbrechen',
      maxSelectedWarning: 'Sie können bis zu 10 Projekte auswählen',
      reportNameRequired: 'Namen des Vergleichsberichts eingeben',
      normRequired: 'Benchmark auswählen',
      projectRequired: 'Projekte auswählen',
    },
    dataComparisonInfoPage: {
      defaultReportName: 'Name des Vergleichsberichts',
      reportNotFound: 'Bericht nicht gefunden',
      back: 'Zurück',
      modify: 'Bearbeiten',
      deletedProjectTip: 'Die folgenden Projekte: {{names}} wurden gelöscht. Nach der Bestätigung wird der Vergleichsbericht aktualisiert und die gelöschten Projekte werden entfernt.',
      confirmDeletedProjects: 'Bestätigen',
      metricScore: 'Indikatorwert',
      tabDimension: 'Fünf Dimensionen',
      tabMoment: 'Schlüsselmoment',
      tabAttitude: 'Konsumentenhaltung',
      adeffScore: 'AdEff-Wert',
      brandName: 'Markenname',
      projectName: 'Projektname',
      industry: 'Branche',
      targetMarket: 'Zielmarkt',
      gender: 'TA-Geschlecht',
      age: 'TA-Alter',
      adProject: 'Werbeprojekt',
      normLabel: 'Benchmark',
      mixedCreativeBenchmarkTip: 'Beim gleichzeitigen Vergleich allgemeiner Creatives und Splash-Creatives ist kein Benchmark verfügbar.',
      emptyProject: 'Wählen Sie Projekte aus, um Vergleichsdaten anzuzeigen',
      viewProjectDetail: 'Projektdetails anzeigen',
      listSeparator: ', ',
      metricLabels: {
        attention: 'Aufmerksamkeitskraft',
        infectivity: 'Emotionale Kraft',
        delivery: 'Botschaftskraft',
        brand: 'Markenkraft',
        persuasion: 'Überzeugungskraft',
        gazeRecognition: 'Blickerkennung',
        emotionRecognition: 'Emotionserkennung',
        engagementRecognition: 'Engagement-Erkennung',
        goldenSeconds: 'Die goldenen 3 Sekunden',
        brandMoment: 'Markenmoment',
        productMoment: 'Interesse-Moment',
        messageMoment: 'Informationsmoment',
        endingSeconds: 'Die letzten 3 Sekunden',
        likeability: 'Gefällt',
        newInformation: 'Neue Informationen',
        messageRelevance: 'Botschaftsrelevanz',
        comprehension: 'Verständnis',
        credibility: 'Glaubwürdigkeit',
        brandLinkage: 'Markenverknüpfung',
        uniqueness: 'Einzigartigkeit',
        learnMoreIntent: 'Bereitschaft, mehr zu erfahren',
        purchaseIntent: 'Kaufabsicht',
        recommendIntent: 'Teilbarkeit',
        brandLikeabilityLift: 'Steigerung der Markenbeliebtheit',
        purchaseIntentionLift: 'Steigerung der Kaufabsicht',
        attentionIndex: 'Aufmerksamkeitsindex',
        emotionIndex: 'Emotionsindex',
        cognitionIndex: 'Kognitionsindex',
      },
    },
    experience: {
      projectDetailPage: {
        analysisCompleted: 'Ihr TVC-Projekt für kreative Bewertung ist abgeschlossen.',
        title: {
          text1: 'Test der Werbekreation',
          text2: 'Testbericht',
        },
        flowAnalysis: {
          desc1: 'AdEff zerlegt Ihre Videoanzeige',
          desc2: 'Videozerlegung abgeschlossen',
          desc3: 'Visuelle Aufmerksamkeit der Verbraucher wird analysiert',
          desc4: 'Analyse des visuellen Fokus auf Basis von Verbraucherprofilen',
          desc5: 'Aufmerksamkeits-Heatmap wird erstellt',
          desc6: 'Dynamische Heatmap wurde erstellt',
          desc7: 'Kognitiv-neuronale Reaktionen werden gemessen',
          desc8: 'Blick, Emotion und Engagement werden Sekunde für Sekunde verfolgt',
          desc9: 'Neuronale Reaktionskurve wird erstellt',
          desc10: 'Neuronale Reaktionskurve wurde erstellt',
          desc11: 'Leistung in Schlüsselmomenten wird analysiert',
          desc12: 'Messung kognitiv-neuronaler Reaktionen während: Goldene 3 Sekunden, Botschaftsmoment, Markenmoment, Interessenshöhepunkt und letzte 3 Sekunden',
          desc13: 'Kennzahlen der Schlüsselmomente werden zusammengeführt',
          desc14: 'Analyse der Schlüsselmomente abgeschlossen',
          desc15: 'Verbrauchereinstellungen werden analysiert',
          desc16: 'Einstellungen zu Marke, Produkt und Inhalt werden analysiert',
          desc17: 'Einstellungskennzahlen werden zusammengeführt',
          desc18: 'Einstellungskennzahlen abgeschlossen',
          desc19: 'Fünf Wirkungsdimensionen werden erstellt',
          desc20: 'Fünf Wirkungsdimensionen sind bereit',
          desc21: 'Analyse abgeschlossen! Ihr Bericht zur Anzeigenleistung ist bereit',
          terminology: {
            thumbExpand: 'Miniaturansichten erweitern',
            thumbCollapse: 'Miniaturansichten einklappen',
            gazeRecognition: 'Blickerkennung',
            gazeRecognitionDesc: 'Misst die Konzentration der visuellen Aufmerksamkeit und zeigt, wie wirksam Werbeelemente den Fokus der Zuschauer erfassen.',
            emotionRecognition: 'Emotionserkennung',
            emotionRecognitionDesc: 'Quantifiziert positive Emotionen und unmittelbare affektive Reaktionen, die durch die Anzeige ausgelöst werden.',
            engagementRecognition: 'Engagement-Erkennung',
            engagementRecognitionDesc: 'Misst Immersion und Engagement und spiegelt die gedankliche Auseinandersetzung mit dem Anzeigeninhalt wider.',
            theGolden3Seconds: 'Leistung der goldenen 3 Sekunden',
            theGolden3SecondsDesc: 'Bewertet die Wirksamkeit des Anzeigeninhalts in den ersten 3 Sekunden.',
            keyMessage: 'Leistung der Kernbotschaft',
            keyMessageDesc: 'Misst die Fähigkeit von Informationsmomenten der Anzeige, Aufmerksamkeit zu erfassen und Interesse zu wecken.',
            brand: 'Markenleistung',
            brandDesc: 'Bewertet die markenspezifische Aufmerksamkeitserfassung und Engagement-Wirksamkeit.',
            interest: 'Interessenshöhepunkt',
            interestDesc: 'Identifiziert Inhaltshöhepunkte, die emotionale Resonanz und hohes Engagement auslösen.',
            ending3Seconds: 'Leistung der letzten 3 Sekunden',
            ending3SecondsDesc: 'Bewertet die Wirksamkeit des Anzeigeninhalts in den letzten 3 Sekunden.',
            score: 'Punktzahl',
            benchmark: 'Benchmark',
            metrics: 'Kennzahlen',
            attitudePart: {
              attitudeMetrics: 'Einstellungskennzahlen',
              liking: 'Gefällt',
              likingDesc: 'Misst die subjektive Haltung des Publikums und den allgemeinen Gefallensgrad gegenüber der Anzeige.',
              newInformation: 'Neue Informationen',
              newInformationDesc: 'Misst, ob das Publikum glaubt, durch die Anzeige zuvor unbekannte, wertvolle Informationen über Marke oder Produkt erhalten zu haben.',
              messageRelevance: 'Botschaftsrelevanz',
              messageRelevanceDesc: 'Misst, inwieweit das Publikum die in der Anzeige vermittelten Informationen als direkt relevant für sich selbst empfindet.',
              comprehension: 'Verständnis',
              comprehensionDesc: 'Misst, ob die Kernbotschaft der Anzeige klar, genau und mühelos verstanden wurde.',
              credibility: 'Glaubwürdigkeit',
              credibilityDesc: 'Misst, inwieweit das Publikum die vermittelten Informationen als wahr, zuverlässig und vertrauenswürdig ansieht.',
              brandLinkage: 'Markenverknüpfung',
              brandLinkageDesc: 'Misst, wie gut das Publikum die Anzeige korrekt und stark mit der jeweiligen Marke verbindet.',
              uniqueness: 'Einzigartigkeit',
              uniquenessDesc: 'Misst, ob die Anzeige eine klare Wahrnehmung einer unverwechselbaren und wertvollen Einzigartigkeit der Marke gegenüber Wettbewerbern schafft.',
              willing: 'Bereitschaft, mehr zu erfahren',
              willingDesc: 'Misst die subjektive Wahrscheinlichkeit, dass das Publikum nach dem Anschauen aktiv mehr über Marke oder Produkt erfahren möchte.',
              purchase: 'Kaufabsicht',
              purchaseDesc: 'Misst die subjektive Wahrscheinlichkeit, dass das Publikum künftig die Marke wählt oder das Produkt kauft.',
              share: 'Teilbarkeit',
              shareDesc: 'Misst die subjektive Wahrscheinlichkeit, dass das Publikum die Anzeige oder Markeninformationen aktiv mit anderen teilt.',
              brandLikeLift: 'Steigerung der Markenbeliebtheit',
              brandLikeLiftDesc: 'Misst Richtung und Ausmaß der Veränderung der allgemeinen Marken- oder Produktbeliebtheit nach Kontakt mit der Anzeige.',
              purchaseIntentLift: 'Steigerung der Kaufabsicht',
              purchaseIntentLiftDesc: 'Misst Richtung und Ausmaß der Veränderung der Bereitschaft, den Kauf des Markenprodukts zu erwägen.',
            },
            dimensionPart: {
              forceDrives: 'Wirkungsdimensionen',
              attension: 'Aufmerksamkeit',
              emotionalImpact: 'Emotionale Wirkung',
              messageClarity: 'Botschaftsklarheit',
              brandPower: 'Markenkraft',
              persuasion: 'Überzeugungskraft',
              attentionForce: 'Aufmerksamkeitskraft',
              attentionForceDesc: 'Misst die Fähigkeit der Anzeige, visuelle und auditive Aufmerksamkeit zu gewinnen und zu halten.',
              emotionalForce: 'Emotionale Kraft',
              emotionalForceDesc: 'Misst die Intensität unmittelbarer, instinktiver emotionaler Resonanz und Schwankung, die durch den Anzeigeninhalt ausgelöst wird.',
              messageForce: 'Botschaftskraft',
              messageForceDesc: 'Misst, wie effektiv die Kernbotschaft der Anzeige von der Zielgruppe klar erkannt, genau verstanden und nachhaltig erinnert wird.',
              brandForce: 'Markenkraft',
              brandForceDesc: 'Misst die Wirksamkeit der Anzeige bei der Stärkung der Markenidentität, der Erhöhung der Markenpräferenz und dem Aufbau einer starken Markenverbindung.',
              persuasiveForce: 'Überzeugungskraft',
              persuasiveForceDesc: 'Misst die finale Kraft der Anzeige, Wahrnehmungen zu verändern und Verhaltensabsichten zu fördern.',
            },
            result: {
              results: 'Ergebnisse',
              pass: 'Bestanden',
              notPass: 'Nicht bestanden',
              adeffScore: 'AdEff-Punktzahl',
              adeffScoreDesc: 'Der AdEff-Score misst die Gesamtwirksamkeit von Anzeigen.',
              benchmarkDesc: 'Der durchschnittliche AdEff-Score aller hochgeladenen Anzeigen im jeweiligen Land oder Gebiet dient als Benchmark für die Anzeigenleistung.',
            },
          },
        },
        pptAnalysis: {
          emptyState: {
            waiting: 'Warten...',
            description: 'Ihr Testbericht wird erstellt...',
          },
          generating: 'Wird erstellt...',
          freeTrialLockText1:
            'Im Testmodus können Sie den vollständigen Bericht weder ansehen noch herunterladen.',
          freeTrialLockText2: 'Abonnieren Sie, um ihn freizuschalten.',
        },
      },
    },
  },
  professor: {
    account: 'Konto',
    password: 'Passwort',
    login: 'Login',
    expertReviews: 'Expertenbewertungen',
    adVideoScore: 'Werbewirkungsindex',
    subjectiveResponseCurve: 'Subjektive Reaktionskurve',
    indexAnalysis: 'Indexanalyse',
    keyResult: 'Kernresultat',
    theGolden3Seconds: 'Die goldenen 3 Sekunden',
    informationTransmission: 'Informationsmoment',
    brandRelevance: 'Markenmoment',
    interestStimulation: 'Interesse-Moment',
    theEnding3Seconds: 'Die letzten 3 Sekunden',
    heatMap: 'Heatmap',
    suggestion: 'Vorschläge',
    suggestion1: 'Vorschlag',
    submit: 'Senden',
    next: 'Weiter',
    summary: 'Zusammenfassung',
    advantages: 'Vorteile',
    disadvantages: 'Nachteile',
    option1: 'Erwartet',
    option2: 'Nicht erwartet',
    resultJudgment: 'Bewertung',
    placeholder: 'Bitte geben Sie eine Empfehlung ein',
    waitRateCount: 'Anzahl der zu bewertenden Werbung',
    unfinishedTitle: 'Benachrichtigung',
    unfinishedRate:
      'Der aktuelle Projekt hat unvollständige Elemente, möchten Sie die Bewertung bestätigen?',
    unfinishedConfirm: 'Weiterbewerten',
    unfinishedCancel: 'Beenden',
    message: {
      submitSuccess: 'Vielen Dank für Ihre Bewertung',
      submitSuccess1:
        'Sie haben die Bewertung dieses Projekts abgeschlossen, danke für Ihre Bewertung',
      loginSuccess: 'Login erfolgreich',
      rateUnfinished:
        'Sie haben den aktuellen Inhalt noch nicht bewertet, bitte ausfüllen, bevor Sie zur nächsten Frage gehen',
      rateLocation: 'Wir haben die unvollständigen Elemente für Sie automatisch ausgewählt',
    },
  },
  modals: {
    freeTrialModal: {
      title: 'Für eine Testversion bewerben',
      title1: 'Kostenlose Testversion',
      trial: 'Testversion',
      hiddenBoxText1: 'Mehrere Vorteile, Nachteile und Vorschläge erkannt',
      hiddenBoxText2: 'Abonnieren, um das vollständige Bericht zu erhalten',
      hiddenBoxBtn: 'Abonnieren',
      applyBox: {
        name: 'Ihr Name',
        tel: 'Kontaktnummer',
        department: 'Abteilung',
        role: 'Rolle',
        country: 'Land',
        city: 'Stadt',
        pleaseEnter: 'Bitte eingeben',
        pleaseSelect: 'Bitte auswählen',
        pleaseEnterTheName: 'Bitte geben Sie Ihren Namen ein',
        pleaseEnterTheTel: 'Bitte geben Sie Ihre Kontaktnummer ein',
        pleaseEnterValidTel: 'Bitte geben Sie eine gültige Kontaktnummer ein',
        pleaseEnterValidEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
        pleaseSelectTheDepartment: 'Bitte wählen Sie Ihre Abteilung',
        pleaseSelectTheRole: 'Bitte wählen Sie Ihre Rolle',
        pleaseSelectTheCountry: 'Bitte wählen Sie Ihr Land',
        pleaseEnterTheCity: 'Bitte geben Sie Ihre Stadt ein',
        textIsRequired: 'Dieses Feld ist erforderlich',
        submit: 'Senden',
        tip: 'Jede Firma hat nur eine kostenlose Testversion',
      },
      gotTrial: 'Sie haben eine Testversion erhalten!',
      goPc: 'Bitte gehen Sie zur PC-Webversion, um Ihr Projekt zu erstellen.',
      back: 'Zurück',
      country: {
        China: 'China',
        Japan: 'Japan',
        Korea: 'Korea',
        Indonesia: 'Indonesien',
        Thailand: 'Thailand',
        Singapore: 'Singapur',
        Malaysia: 'Malaysia',
        Vietnam: 'Vietnam',
        Germany: 'Deutschland',
        Britain: 'Vereinigtes Königreich',
        France: 'Frankreich',
        Italy: 'Italien',
        Russia: 'Russland',
        Spain: 'Spanien',
        Turkey: 'Türkei',
        America: 'Vereinigte Staaten',
        Canada: 'Kanada',
        Brazil: 'Brasilien',
        Other: 'Andere',
      },
      department: {
        Brand: 'Marken',
        Market: 'Markt',
        Marketing: 'Marketing',
        IT: 'IT',
        Procurement: 'Einkauf',
        Other: 'Andere',
      },
      role: {
        President: 'Präsident/Vizepräsident/Geschäftsführer',
        CMO: 'CMO oder andere C-Level-Management',
        Director: 'Abteilungsleiter',
        Manager: 'Abteilungsleiter',
        Other: 'Andere',
      },
      message: {
        submitSuccess: 'Eingabe erfolgreich',
        submitFailed: 'Eingabe fehlgeschlagen, bitte versuchen Sie es später erneut',
      },
    },
    downloadPptRechargeModal: {
      title: 'Bericht kann nicht heruntergeladen werden',
      desc1: 'In der Testversion kann kein Bericht heruntergeladen werden',
      desc2: 'Abonnieren, um das vollständige Bericht zu erhalten',
      btn: 'Abonnieren',
    },
    checkInvitationCodeModal: {
      invitationCode: 'Empfehlungscode',
      invitationCodeDesc1:
        'Empfehlungscode kann nicht geändert werden, bitte kontaktieren Sie uns, wenn Sie ihn ändern möchten',
      invitationCodeDesc2:
        'Wenn Sie dies über eine Agentur-Empfehlung nutzen, geben Sie bitte den Empfehlungscode ein',
      invitationCodePlaceholder: 'Bitte geben Sie den Empfehlungscode ein',
      invitationCodeError: 'Ungültiger Empfehlungscode',
      invitationCodeSuccess: 'Empfehlungscode erfolgreich',
      ok: 'OK',
      cancel: 'Abbrechen',
    },
    aigcPromotionModal: {
      title: 'AIGC Creator Vorteile',
      subTitle: 'Jetzt registrieren und <tmp>5</tmp> KI-Video-Bewertungen erhalten',
      desc1: 'Nimm am AdEff KI-Creative-Testing-Event teil und bewerte deine Creatives.',
      desc2: 'Registriere dich jetzt und sichere dir sofort 5 kostenlose Tests.',
      registerBtn: 'Registrieren und Testchancen erhalten',
      tip: 'Nur für neue Nutzer, die sich über den Kampagneneinstieg für AIGC Creator registrieren',
      floatTitle: 'Kostenloser Test',
    },
  },
}

export default TRANSLATION
